<template lang="pug" src="./slider-text.pug"></template>

<script>
import Icon from 'components/icon/icon'
import SliderTextDirective from './slider-text.directive'

export default {
  props: ['content'],
  components: {
    Icon
  },
  directives: {
    SliderTextDirective
  }
}
</script>



// WEBPACK FOOTER //
// slider-text.vue?353ed634